const { ajaxHandler, isMobileDevice } = require("./utilities/utilities");


document.addEventListener('DOMContentLoaded', function () {
    /**
     * Platform user login.
     *
     * @since 1.0.0
     */
    const loginForm = document.getElementById('platform-login');
    const loginError = document.querySelector('.platform-login-error');

    if (loginForm) {

        /**
         * Manage redirect URL
         */
        const urlParams = new URLSearchParams(window.location.search);
        const redirectUrl = urlParams.get('redirect');
        const redirectInput = document.querySelector('input[name="redirect"]')

        if (redirectInput) {
            redirectInput.value = redirectUrl
        }

        loginForm.addEventListener('submit', async (e) => {
            const btnSubmit = e.target.querySelector('button[type="submit"]'),
                spinner = btnSubmit.querySelector('.platform-spinner-border'),
                spinnerText = btnSubmit.querySelector('span[role=status]');

            if (!loginForm.checkValidity()) {
                e.preventDefault();
                return loginForm.classList.add("platform-was-validated");
            }

            btnSubmit.setAttribute('disabled', 'disabled');
            spinner.classList.remove('platform-d-none');
            spinnerText.innerHTML = 'Processing...'

        });
    }

    /**
     * Platform user register.
     *
     * @since 1.0.0
     */
    const registerForm = document.getElementById('platform-register');
    const registerError = document.querySelector('.platform-register-error');
    const registerSuccess = document.querySelector('.platform-register-success');

    if (registerForm) {
        registerForm.addEventListener('submit', async (e) => {
            e.preventDefault();

            const btnSubmit = e.target.querySelector('button[type="submit"]'),
                spinner = btnSubmit.querySelector('.platform-spinner-border'),
                spinnerText = btnSubmit.querySelector('span[role=status]'),
                oldText = spinnerText.innerHTML;

            if (!registerForm.checkValidity()) {
                return registerForm.classList.add('platform-was-validated');
            }

            const formData = new FormData(registerForm);

            registerError.classList.add('platform-d-none');
            btnSubmit.setAttribute('disabled', 'disabled');
            spinner.classList.remove('platform-d-none');
            spinnerText.innerHTML = 'Processing...'

            const res = await ajaxHandler(formData);
            const { success, message } = res;

            btnSubmit.removeAttribute('disabled');
            spinnerText.innerHTML = oldText
            spinner.classList.add('platform-d-none');

            if (success) {
                registerForm.classList.remove('platform-was-validated');
                registerForm.reset();
                btnSubmit.setAttribute('disabled', '');

                registerSuccess.innerHTML = message;
                registerSuccess.classList.remove('platform-d-none');
            } else {
                registerError.classList.remove('platform-d-none');
                registerError.innerHTML = message;
            }

        });
    }

    /**
     * Platform forgot password
     *
     * @since 1.0.0
     */
    const forgotPasswordForm = document.getElementById('platform-forgot-password');
    const forgotPasswordError = document.querySelector('.platform-forgot-password-error');
    const forgotPasswordSuccess = document.querySelector('.platform-forgot-password-success');

    if (forgotPasswordForm) {
        forgotPasswordForm.addEventListener('submit', async (e) => {
            e.preventDefault();

            const btnSubmit = e.target.querySelector('button[type="submit"]'),
                spinner = btnSubmit.querySelector('.platform-spinner-border'),
                spinnerText = btnSubmit.querySelector('span[role=status]'),
                oldText = spinnerText.innerHTML;


            if (!forgotPasswordForm.checkValidity()) {
                return forgotPasswordForm.classList.add("platform-was-validated");
            }

            forgotPasswordError.classList.add('platform-d-none');
            btnSubmit.setAttribute('disabled', 'disabled');
            spinner.classList.remove('platform-d-none');
            spinnerText.innerHTML = 'Processing...'

            const formData = new FormData(forgotPasswordForm);

            const res = await ajaxHandler(formData);

            btnSubmit.removeAttribute('disabled');
            spinnerText.innerHTML = oldText
            spinner.classList.add('platform-d-none');

            const { success, message } = res;
            if (success) {
                forgotPasswordForm.reset();

                btnSubmit.setAttribute('disabled', '');
                forgotPasswordSuccess.classList.remove('platform-d-none')
                forgotPasswordSuccess.innerHTML = message
            } else {
                forgotPasswordError.classList.remove('platform-d-none')
                forgotPasswordError.innerHTML = message;
            }
        });
    }

    /**
     * Platform reset password
     *
     * @since 1.0.0
     */
    const resetPasswordForm = document.getElementById('platform-reset-password');
    const resetPasswordError = document.querySelector('.platform-reset-password-error');
    const resetPasswordSuccess = document.querySelector('.platform-reset-password-success');

    if (resetPasswordForm) {
        resetPasswordForm.addEventListener('submit', async (e) => {
            e.preventDefault();

            const btnSubmit = e.target.querySelector('button[type="submit"]'),
                spinner = btnSubmit.querySelector('.platform-spinner-border'),
                spinnerText = btnSubmit.querySelector('span[role=status]'),
                oldText = spinnerText.innerHTML;


            if (!resetPasswordForm.checkValidity()) {
                return resetPasswordForm.classList.add("platform-was-validated");
            }

            resetPasswordError.classList.add('platform-d-none');
            btnSubmit.setAttribute('disabled', 'disabled');
            spinner.classList.remove('platform-d-none');
            spinnerText.innerHTML = 'Processing...'

            const formData = new FormData(resetPasswordForm);

            const res = await ajaxHandler(formData);

            btnSubmit.removeAttribute('disabled');
            spinnerText.innerHTML = oldText;
            spinner.classList.add('platform-d-none');

            const { success, message } = res;
            if (success) {
                resetPasswordForm.reset();

                btnSubmit.setAttribute('disabled', '');
                window.location.href = `${message.redirect_url}?password-reset=true`;
            } else {
                resetPasswordError.classList.remove('platform-d-none');
                resetPasswordError.innerHTML = message;
            }
        });
    }

    // Remove classes for smaller devices
    if (isMobileDevice() && (loginForm || registerForm)) {
        const inputs = document.querySelectorAll('input.platform-form-control-lg');
        const labels = document.querySelectorAll('label.platform-form-label.platform-fs-4');

        labels.forEach(function (label) {
            label.classList.remove('platform-fs-4');
        });

        inputs.forEach(function (input) {
            input.classList.remove('platform-form-control-lg');
        });
    }
})
